import React, { forwardRef, MouseEventHandler } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { bemClassNames } from "@multiweb/reactUtils";
import { ForwardRefType, LinkTargetOptions, TextAlign } from "@multiweb/types/react";
import { Role } from "@multiweb/uiShared/Role";
import { ButtonFake } from "../ButtonFake";
import { ButtonProvider } from "../ButtonProvider";
import { MultiEditWrapper } from "../MultiEditWrapper";
import { Text, WhiteSpace } from "../Text";
import { TextButtonSpacing } from "../TextButtonSpacing";
import { ComponentSize, MultiEditProps } from "../types";

const { openUrl } = bridge;

const classNames = bemClassNames("link-button-component");

export type LinkButtonComponentProps = {
    /** Adresa odkazu */
    url?: string;
    /** Text odkazu */
    text?: string;
    /** Text nápovědy */
    title?: string;
    /** Způsob jakým se má odkaz otevřít */
    target?: LinkTargetOptions;
    /** Callback volaný na kliknutí */
    onClick?: MouseEventHandler<HTMLButtonElement>;
    /** Příznak, zda má tlačítko vykreslit loading indikátor */
    isLoading?: boolean;
    /** Příznak, zda má být tlačítko aktivní */
    enabled?: boolean;
    /** Lokalizační klíč */
    locKey: string;
} & Omit<MultiEditProps, "ref">;

/** Komponenta tlačítka otevírající URL adresy */
export const LinkButtonComponent: ForwardRefType<HTMLInputElement, LinkButtonComponentProps> = forwardRef<HTMLInputElement, LinkButtonComponentProps>(({
    url,
    text,
    title,
    target = LinkTargetOptions.blank,
    enabled,
    isLoading,
    multiEditActive,
    locKey,
    onClick = () => {
        if (url && enabled)
            openUrl(url, target);
    },
// Reference je zde kvůli EditableControlConnectoru.
// @ts-ignore
// eslint-disable-next-line unused-imports/no-unused-vars
}, ref) => {
    const fakeComponentRenderer = () => <ButtonFake locKey={locKey} />;

    return (
        <div className={classNames()}>
            <MultiEditWrapper fakeComponentRenderer={fakeComponentRenderer} touched={false} multiEditActive={multiEditActive}>
                {() => {
                    return <ButtonProvider {...{ onClick, title, isLoading }} role={Role.link} disabled={!enabled}
                        width="100%" height="100%" textAlign={TextAlign.center}>
                        <TextButtonSpacing size={ComponentSize.small}>
                            <Text
                                isTextSelectable={false}
                                value={text}
                                whiteSpace={WhiteSpace.nowrap}
                                ellipsis={true}
                                underline={true}
                            />
                        </TextButtonSpacing>
                    </ButtonProvider>;
                }}
            </MultiEditWrapper>
        </div>
    );
});
